// extracted by mini-css-extract-plugin
export default {"teachersContainer":"Teachers_teachersContainer__u8oTu","header":"Teachers_header__SBWlK"};